import type { ScrapingState } from "@shared/types/socket";
import { connectScrapingSocket, initScrapingJob, type ScrapingSocketHandlers } from "@shared/utils";
import { getSocketAuth } from "./session";

const startScraping = async (state: ScrapingState) => {
  state.setScraping(true);
  state.setRawLogs([]);

  try {
    const { jobId, addressTree } = await initScrapingJob();
    if (!state.mountedRef.current) return;
    state.setInitialAddresses(addressTree);

    const auth = await getSocketAuth();

    const handlers: ScrapingSocketHandlers = {
      onLog: (log) => {
        if (!state.mountedRef.current) return;
        state.setRawLogs((prev) => [...prev, log]);
      },
      onDone: () => {
        if (state.mountedRef.current) state.setScraping(false);
      },
      onError: () => {
        if (state.mountedRef.current) state.setScraping(false);
      },
    };

    connectScrapingSocket(jobId, handlers, auth);
  } catch {
    if (state.mountedRef.current) state.setScraping(false);
  }
};

export { startScraping };
